function observeHiddenElements() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(entry);
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('hidden-animation-cards')) {
            entry.target.classList.add('show-cards');
          }
          if (entry.target.classList.contains('hidden-animation-slideshow')) {
            entry.target.classList.add('show-slideshow');
          }
          if (entry.target.classList.contains('animation-slideshow-button')) {
            entry.target.classList.add('show-slideshow-button');
          }
          if (entry.target.classList.contains('hidden-animation-slideshow-sub')) {
            entry.target.classList.add('show-slideshow-sub');
          }
          if (entry.target.classList.contains('hidden-animation-testimonials')) {
            entry.target.classList.add('show-animation-testimonials');
          }
          if (entry.target.classList.contains('hidden-animation-overlapping-images')) {
            entry.target.classList.add('show-animation-overlapping-images');
          }
        } else {
          entry.target.classList.remove('show-slideshow', 'show-slideshow-sub', 'show-slideshow-button');
        }
      });
    });
    
    const hiddenElements = document.querySelectorAll('.hidden-animation-overlapping-images, .animation-slideshow-button, .hidden-animation-cards, .hidden-animation-slideshow, .hidden-animation-testimonials, .hidden-animation-slideshow-sub, .hidden-animation-slideshow-button');
    hiddenElements.forEach((el) => observer.observe(el));
  }

  window.addEventListener('DOMContentLoaded', (event) => {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });
  
  document.addEventListener("shopify:section:load", function(event) {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });